import { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../lib/auth';

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await requestPasswordReset(email);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'En feil oppstod');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Sjekk e-posten din
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Hvis e-postadressen finnes i systemet, har vi sendt deg en lenke for å tilbakestille passordet ditt.
            </p>
          </div>
          <div className="bg-green-50 border border-green-200 rounded-md p-4">
            <p className="text-sm text-green-800">
              E-post sendt til <strong>{email}</strong>
            </p>
            <p className="text-sm text-green-800 mt-2">
              Lenken er gyldig i 1 time.
            </p>
          </div>
          <div className="text-center">
            <Link
              to="/login"
              className="text-sm text-kf-primary hover:text-kf-secondary"
            >
              Tilbake til innlogging
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Glemt passord?
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Skriv inn e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}
          <div>
            <label htmlFor="email" className="label">
              E-postadresse
            </label>
            <input
              id="email"
              type="email"
              required
              className="input"
              placeholder="din@epost.no"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary w-full"
          >
            {loading ? 'Sender...' : 'Send tilbakestillingslenke'}
          </button>

          <div className="text-center">
            <Link
              to="/login"
              className="text-sm text-kf-primary hover:text-kf-secondary"
            >
              Tilbake til innlogging
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
